var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgrade({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1724382550079,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5095,
    width: 26,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 55.25732C260.169881 55.25732 55.308484 260.118717 55.308484 511.948836s204.861397 456.691516 456.691516 456.691516 456.691516-204.861397 456.691516-456.691516S763.830119 55.25732 512 55.25732z m0 820.264215C311.538723 875.521535 148.427301 712.410113 148.427301 511.948836S311.538723 148.376137 512 148.376137s363.572699 163.111422 363.572699 363.572699-163.111422 363.572699-363.572699 363.572699z",
    fill: "#8a8a8a",
    "p-id": 5096
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M548.838213 302.687319c-8.493255-8.493255-19.647047-12.688718-31.107824-13.098032-1.22794-0.204657-2.455881-0.102328-3.683822-0.204656-1.22794 0.102328-2.455881 0-3.683821 0.204656-11.460777 0.409313-22.61457 4.604777-31.107824 13.098032L320.134306 461.705606c-18.21445 18.21445-18.21445 47.68502 0 65.797142 18.21445 18.21445 47.582692 18.21445 65.797142 0l79.509144-79.509144v240.062357c0 25.684421 20.874988 46.559408 46.559408 46.559408 0.716299 0 1.330269-0.204657 1.944239-0.204656 0.61397 0 1.22794 0.204657 1.944239 0.204656 25.684421 0 46.559408-20.874988 46.559408-46.559408V447.891276l79.509144 79.509144c18.21445 18.21445 47.582692 18.21445 65.797142 0 18.21445-18.112122 18.21445-47.582692 0-65.797142L548.838213 302.687319z",
    fill: "#8a8a8a",
    "p-id": 5097
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrade);
export default __webpack_public_path__ + "static/media/Upgrade.7b8b071862e175de899bebdaa39abc3e.svg";
export { ForwardRef as ReactComponent };